import React, { useState, useEffect } from "react";
// import superAdminData from "../../SUPER-ADMIN-JSON.json";
import InputDropdown from "./InputDropdown";
import axios from "axios";
import link from "../../../Utils/Settings";
import settings from "../../../Utils/Settings1";
import { currentUserID } from "../../../Utils/USER";
import { toast } from "react-hot-toast";
import { GoEye, GoEyeClosed } from "react-icons/go";
import { v4 as uuidv4 } from "uuid";

const { superHospitalForm } = settings;

const Hospital = ({ superAdminData, setSidebarOpen, reloadTable1 }) => {
  const [loading, setLoading] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const reload = () => {
    console.log("meow")
    reloadTable1()

  };
  const [formData, setFormData] = useState({
    user_id: currentUserID,
    Name: "",
    Email: "",
    Address: "",
    City: "",
    Pincode: "",
    Registration_ID: "",
    Contact_Number: "",
    certificate: "",
    logo: "",
    Password: "",
  });
  // Added state variable to store error for particular fields
  const [formErrors, setFormErrors] = useState({
    Name: "",
    Email: "",
    Address: "",
    City: "",
    Pincode: "",
    Registration_ID: "",
    Contact_Number: "",
    logo: "",
    Password: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordChecklist, setShowPasswordChecklist] = useState(false);
  const [passwordConditions, setPasswordConditions] = useState({
    minLength: false,
    specialChar: false,
    number: false,
    capital: false,
    lowercase: false,
  });

  function handleInputChange(event) {
    const { name, value, files } = event.target;
    let error = "";
    setFormData({ ...formData, [name]: value });

    if (name === "Password") {
      // Update password conditions
      const conditions = {
        minLength: value.length >= 8,
        specialChar: /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/.test(value),
        number: /[0-9]+/.test(value),
        capital: /[A-Z]+/.test(value),
        lowercase: /[a-z]+/.test(value),
      };
      setPasswordConditions(conditions);
    }
    if (name === "certificate") {
      // Check if the selected file type is PNG or JPEG
      const fileType = files[0].type;
      const allowedTypes = ["application/pdf"];
      if (!allowedTypes.includes(fileType)) {
        error = "Please upload a PDF file";
        setFormErrors({ ...formErrors, [name]: error });
        return;
      }
    }
    // added logic for validation of email,pincode,etc
    switch (name) {
      case "Email":
        // Add email validation logic
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        error = !value.match(emailRegex) ? "Invalid email address" : "";
        break;
      case "Contact_Number":
        error = isNaN(value) ? "Please enter a numerical value" : "";
        break;
      case "Registration_ID":
        // Check for non-numerical values
        error = isNaN(value) ? "Please enter a numerical value" : "";
        break;
      case "certificate":
        // Check for non-numerical values
        error = files[0] ? "" : "Please Upload the certificate";
        break;
      default:
        break;
    }

    setFormErrors({ ...formErrors, [name]: error });

    if (name === "certificate" || name === "logo") {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  }

  function checkFields() {
    const {
      Name,
      Email,
      Password,
      Contact_Number,
      City,
      Address,
      Registration_ID,
      certificate,
    } = formData;
    const obj = {
      Name,
      Email,
      Password,
      Contact_Number,
      City,
      Address,
      Registration_ID,
      certificate,
    };
    // added logic for validation on submit
    const errors = {};
    Object.keys(obj).forEach((key) => {
      if (key === "Email") {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        errors[key] = !obj[key].match(emailRegex)
          ? "Invalid email address"
          : "";
      } else if (key === certificate) {
        errors[key] =
          obj[key] instanceof File ? "" : "Please upload the documents";
      } else {
        errors[key] = obj[key] ? "" : "This field is required";
      }
    });

    setFormErrors(errors);

    return Object.values(errors).every((e) => e === "");
  }

  async function handleSubmit() {
    const isValid = checkFields();
    const allConditionsMet = Object.values(passwordConditions).every(
      (condition) => condition === true
    );

    if (!allConditionsMet) {
      toast.error("Password does not meet all requirements");
      return;
    }

    if (isValid) {
      setShowConfirmationModal(true); // Show confirmation modal
    } else {
      const firstErrorInput = document.querySelector(".border-red-500");
      if (firstErrorInput) {
        firstErrorInput.focus();
      }
      toast.error("Please fix the errors in the form");
    }
  }

  const handleConfirmation = async () => {
    // Submit the form data
    const formDataToSend = new FormData();
    formDataToSend.append("UserId", formData.user_id);
    formDataToSend.append("RequestId", uuidv4());
    formDataToSend.append("MessageId", uuidv4());
    formDataToSend.append("MessageType", superHospitalForm.split('/').pop());
    Object.keys(formData).forEach((key) => {
      if (key !== "user_id") {
        formDataToSend.append(key, formData[key]);
      }
    });
    try {
      setLoading(true);
      // changed from Super_Hospital_Registration to Super_Hospital_Update_Form
      const res = await axios.post(
        superHospitalForm,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log(res);

      if (res.status == 201) {
        toast.success("Submitted");
        console.log("Form submitted successfully");
        setTimeout(function () {
          // window.location.reload();
          reload()
        }, 1000);
      } else {
        console.error("Failed to submit form");
      }
    } catch (error) {
      toast.error("Error submitting form");
      console.error("Error submitting form:", error);
    } finally {
      setLoading(false);
      setSidebarOpen(false);
      setShowConfirmationModal(false);
    }
  };

  const loader = (
    <div className="w-[1.5rem] h-[1.5rem] mx-auto animate-spin bg-transparent rounded-full border-2 border-r-2 border-t-2 border-l-transparent border-b-transparent border-red"></div>
  );
  useEffect(() => {
    console.log(formData);
  }, [formData]);

  return (
    <div className=" flex flex-col mx-4 my-4 overflow-y-scroll pb-[130px] h-full no-scrollbar">
      <h1 className="text-2xl text-center mb-6 mt-6 font-bold p-4">
        Add Hospital
      </h1>
      <div className="flex flex-col gap-y-6 ">
        <div className="flex flex-col  gap-y-2">
          <label htmlFor="Name">Name</label>
          <input
            className={`px-1 py-2 border rounded-md focus:outline-none ${formErrors.Name && "border-red-500"
              }`}
            type="text"
            name="Name"
            id="name"
            value={formData.Name}
            onChange={handleInputChange}
          />
          {formErrors.Name && (
            <span className="text-red-500 text-sm">{formErrors.Name}</span>
          )}
        </div>
        <div className="flex flex-col  gap-y-2">
          <label htmlFor="Email">Email</label>
          <input
            className={`px-1 py-2 border rounded-md focus:outline-none ${formErrors.Email && "border-red-500"
              }`}
            type="text"
            name="Email"
            id="email"
            value={formData.Email}
            onChange={handleInputChange}
          />
          {formErrors.Email && (
            <span className="text-red-500 text-sm">{formErrors.Email}</span>
            //the above span element shows error message below the input box
          )}
        </div>
        <div className="flex flex-col  gap-y-2">
          <label htmlFor="Address">Address</label>
          <input
            className={`px-1 py-2 border rounded-md focus:outline-none ${formErrors.Address && "border-red-500"
              }`}
            type="text"
            name="Address"
            id="address"
            value={formData.Address}
            onChange={handleInputChange}
          />
          {formErrors.Address && (
            <span className="text-red-500 text-sm">{formErrors.Address}</span>
          )}
        </div>
        <div className="flex flex-col  gap-y-2">
          <label htmlFor="City">City</label>
          <input
            className={`px-1 py-2 border rounded-md focus:outline-none ${formErrors.City && "border-red-500"
              }`}
            type="text"
            name="City"
            id="city"
            value={formData.City}
            onChange={handleInputChange}
          />
          {formErrors.City && (
            <span className="text-red-500 text-sm">{formErrors.City}</span>
          )}
        </div>
        <div className="flex flex-col  gap-y-2">
          <label htmlFor="Pincode">Pincode</label>
          <input
            className={`px-1 py-2 border rounded-md focus:outline-none ${formErrors.Pincode && "border-red-500"
              }`}
            type="text"
            name="Pincode"
            id="pincode"
            value={formData.Pincode}
            onChange={handleInputChange}
          />
        </div>
        <div className="flex flex-col  gap-y-2">
          <label htmlFor="Registration_ID">Registration No.</label>
          <input
            className={`px-1 py-2 border rounded-md focus:outline-none ${formErrors.Registration_ID && "border-red-500"
              }`}
            type="text"
            name="Registration_ID"
            id="regId"
            value={formData.Registration_ID}
            onChange={handleInputChange}
          />
          {formErrors.Registration_ID && (
            <span className="text-red-500 text-sm">
              {formErrors.Registration_ID}
            </span>
          )}
        </div>
        <div className="flex flex-col  gap-y-2">
          <label htmlFor="Contact_Number">Contact Number</label>
          <input
            className={`px-1 py-2 border rounded-md focus:outline-none ${formErrors.Contact_Number && "border-red-500"
              }`}
            type="tel"
            name="Contact_Number"
            id="phone"
            value={formData.Contact_Number}
            onChange={handleInputChange}
          />
          {formErrors.Contact_Number && (
            <span className="text-red-500 text-sm">
              {formErrors.Contact_Number}
            </span>
          )}
        </div>
        <div className="flex flex-col  gap-y-2">
          <label htmlFor="certificate">Certificate</label>
          <input
            className={`px-1 py-2 border rounded-md focus:outline-none ${formErrors.certificate && "border-red-500"
              }`}
            type="file"
            name="certificate"
            id="certificate"
            onChange={handleInputChange}
          />
          {formErrors.certificate && (
            <span className="text-red-500 text-sm">
              {formErrors.certificate}
            </span>
          )}
        </div>
        <div className="flex flex-col  gap-y-2">
          <label htmlFor="logo">Logo</label>
          <input
            className={`px-1 py-2 border rounded-md focus:outline-none ${formErrors.logo && "border-red-500"
              }`}
            type="file"
            name="logo"
            id="logo"
            onChange={handleInputChange}
          />
          {formErrors.logo && (
            <span className="text-red-500 text-sm">{formErrors.logo}</span>
          )}
        </div>
        <div className="flex flex-col  gap-y-2 relative">
          <label htmlFor="Password">Password</label>
          <input
            className={`px-1 py-2 border rounded-md focus:outline-none ${formErrors.Password && "border-red-500"
              }`}
            type={showPassword ? "text" : "password"}
            name="Password"
            id="pass"
            value={formData.Password}
            onChange={handleInputChange}
            onFocus={() => setShowPasswordChecklist(true)}
            onBlur={() => setShowPasswordChecklist(false)}
          />
          {formErrors.Password && (
            <span className="text-red-500 text-sm">{formErrors.Password}</span>
          )}
          {showPasswordChecklist && (
            <div className="absolute top-[75px] left-0 z-50 w-[352px] bg-white shadow-lg border border-gray-200 rounded p-4">
              <ul className="list-disc pl-0.1 text-sm text-gray-800">
                <ul className="list-disc pl-5 text-xs">
                  <li
                    style={{
                      color: passwordConditions.minLength
                        ? "#36AE78"
                        : "#FF5B5B",
                    }}
                  >
                    Password must be at least 8 characters long
                  </li>
                  <li
                    style={{
                      color: passwordConditions.specialChar
                        ? "#36AE78"
                        : "#FF5B5B",
                    }}
                  >
                    Password must contain a special character
                  </li>
                  <li
                    style={{
                      color: passwordConditions.number ? "#36AE78" : "#FF5B5B",
                    }}
                  >
                    Password must contain a number
                  </li>
                  <li
                    style={{
                      color: passwordConditions.capital ? "#36AE78" : "#FF5B5B",
                    }}
                  >
                    Password must contain a capital letter
                  </li>
                  <li
                    style={{
                      color: passwordConditions.lowercase
                        ? "#36AE78"
                        : "#FF5B5B",
                    }}
                  >
                    Password must contain a lowercase letter
                  </li>
                </ul>
              </ul>
            </div>
          )}
          <button
            type="button"
            className="absolute top-[50px] right-1 transform -translate-y-1/2"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <GoEyeClosed /> : <GoEye />}
          </button>
        </div>
      </div>
      <button
        className="text-sm w-full font-medium rounded-lg text-white mt-8 px-6 py-2 bg-[#4A4A4A] active:scale-95 active:transform transition-transform duration-300 focus:outline-none"
        onClick={handleSubmit}
      >
        {loading ? loader : "Sign up"}
      </button>

      {showConfirmationModal && (
        <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center z-50">
          <div className="bg-[#ededed] p-8 w-[640px] h-[14rem] rounded-3xl items-center m-[20px]">
            <p className="text-xl font-semibold mb-1 text-center">Are you sure you want to </p>
            <p className="text-2xl font-semibold mb-4 text-center">Submit the form?</p>
            <div className="flex justify-center">
              <button
                className="font-semibold rounded-lg px-4 py-2 mr-7 w-[180px] mt-[20px] border border-red-500 bg-white text-red-500"
                onClick={() => setShowConfirmationModal(false)}
              >
                No
              </button>
              <button
                className="text-white bg-[#36AE78] rounded-lg px-4 py-2 w-[180px] mt-[20px] font-semibold"
                onClick={handleConfirmation}
              >
                {loading ? loader : "Yes"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Hospital;
